'use client'

import { useEffect } from 'react'

import { usePathname, useRouter } from '@/i18n/routing'
import { resolveForClubsFanRedirect } from '@/lib/routing/resolveForClubsFanRedirect'
import { useAuth } from '@/providers/AuthProvider'
import { getAuthTokenPayload } from '@/utils/auth'

const ForClubsAuthRedirect = () => {
  const router = useRouter()
  const pathname = usePathname()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    const target = resolveForClubsFanRedirect(
      pathname,
      getAuthTokenPayload()?.roles
    )
    if (target) {
      router.replace(target)
    }
  }, [isAuthenticated, pathname, router])

  return null
}

export default ForClubsAuthRedirect
